<template>
  <div>
    <vs-popup
      fullscreen
      :title="$t('AssignProductToContract')"
      :active.sync="showModal"
      id="assign-product-popup"
    >
      <div class="vx-card mb-4">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <div class="vx-card__body card-body">
            <div class="vx-row">
              <div class="vx-col w-full">
                <form>
                  <div class="vx-row">
                    <div class="vx-col lg:w-3/4">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.Name"
                        :label="$t('ProductName')"
                      />
                    </div>
                    <div class="vx-col lg:w-1/4  mt-5">
                      <vs-button
                        type="filled"
                        class="float-right"
                        @click.prevent="submitFilter()"
                        >{{ $t("SubmitFilter") }}</vs-button
                      >
                      <vs-button
                        type="filled"
                        class="float-right ml-4"
                        id="reset-btn"
                        @click.prevent="resetForm"
                        >{{ $t("ResetFilter") }}</vs-button
                      >
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :search-data="gridSearchData"
            :columns="[
              { title: $t('ProductName') },
              { title: $t('PersianName') },
              { title: $t('ItemCode') },
              { title: $t('ModelNumber') },
              { title: $t('Action') }
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width:26%">{{ row.name }}</td>
              <td style="width:26%">{{ row.persianName }}</td>
              <td style="width:15%">{{ row.itemCode }}</td>
              <td style="width:15%">{{ row.modelNumber }}</td>
              <td style="width:15%">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="view-btn"
                  @click.prevent="add(row.id)"
                ></vs-button>
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<style lang="scss">
#assign-product-popup .vs-popup--content {
  overflow-y: scroll !important;
}
</style>
<script>
import { mapActions } from "vuex";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "saleManagement_Contract_Management_AssignConfigurableProductPopup",
  props: {
    show: { default: false }
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Sales/api/ProductQuery/name/configurable"
      },
      gridSearchData: {},
      proInfo: {
        contractId: null,
        productIds: [null]
      }
    };
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish");
      }
    }
  },
  components: {
    DataGrid
  },
  methods: {
    ...mapActions({
      assignContractConfigurableProductsInfo:
        "sale/assignContractConfigurableProductsInfo"
    }),
    submitFilter() {
      this.$refs.grid.renderGrid(1);
    },
    resetForm() {
      this.gridSearchData = {
        Name: ""
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    add(id) {
      var contractId = this.$route.params.id;
      this.proInfo = {
        contractId: contractId,
        productIds: [id]
      };
      this.assignContractConfigurableProductsInfo(this.proInfo).then(() => {
        this.$vs.notify({
          title: "عملیات موفق",
          text: "محصول به قرارداد موردنظر افزوده شد!",
          color: "success"
        });
      });
    }
  }
};
</script>
